import { FC } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  width: 165px;
  height: 35px;
  @media (max-width: 767px) {
    width: 120px;
    height: 30px;
  }
`;

const Container = styled.span`
  background: #fff;
  display: grid;
  grid-template-columns: 28px 1fr 28px;
  align-items: center;
  @media (max-width: 767px) {
    grid-template-columns: 24px 1fr 24px;
  }
`;

const Button = styled.button`
  padding: 0;
  background-color: rgb(18, 18, 18);
  border: 0;
  width: 28px;
  height: 35px;
  color: #fff;
  cursor: pointer;
  display: grid;
  place-items: center;

  @media (max-width: 767px) {
    padding: 0;
    height: 30px;
    width: 24px;
  }
`;

const ValueView = styled.input`
  background: #9b9b9b1a !important;
  display: inline-block;
  width: 104px;
  height: 35px;
  text-align: center;
  border: 0;
  -moz-appearance: textfield;
  cursor: default;
  color: #000;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &[disabled] {
    background: #9b9b9b1a !important;
  }
  &[readonly] {
    opacity: 1;
  }

  @media (max-width: 767px) {
    width: 72px;
    height: 30px;
  }
`;

type Props = {
  min?: number;
  max?: number;
  value?: number;
  onChange?: (value: number) => void;
};

export const SpinButton: FC<Props> = ({ min, max, value, onChange }) => {
  const onClickPlus = () => {
    console.log(value);
    let v = value ? value! : 0;
    if ((typeof max === 'undefined' || max >= v + 1) && onChange) {
      onChange(v + 1);
    }
  };

  const onClickMinus = () => {
    console.log(value);
    let v = value ? value! : 0;
    if ((typeof min === 'undefined' || min <= v - 1) && onChange) {
      onChange(v - 1);
    }
  };

  return (
    <Wrapper>
      <Container>
        <Button onClick={onClickMinus}>−</Button>
        <ValueView type={'number'} min={min} max={max} value={value} readOnly={true} disabled={true} />
        <Button onClick={onClickPlus}>＋</Button>
      </Container>
    </Wrapper>
  );
};
